export default __webpack_public_path__ + "static/media/i221vp.0611c716.webp";